/**
 * @file 个人中心
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {
    GET_GET_LIST,
    GET_FEEDBACK_DETAIL,
    GET_COMPANY_DETAIL,
    GET_COMPANY_DATA,
    GET_PAID_ATTEST_LIST
} from './ActionTypes';

export function fetchGetList(dispatch, type, params) {
    return rcAjax('POST', `/api/v1/${type}/getList`, {}, params, data => {
        dispatch({type: GET_GET_LIST, data: data.data});
    });
}
export function fetchGetPaidAttestList(dispatch, params) {
    return rcAjax('GET', '/api/v1/cloud/dashboard/comsv2', params, {}, data => {
        dispatch({type: GET_PAID_ATTEST_LIST, data: data.data});
    });
}

export function fetchFeedbackDetail(dispatch, params) {
    return rcAjax('POST', '/api/v1/feedback/getDetail', {}, params, data => {
        dispatch({type: GET_FEEDBACK_DETAIL, data: data.data});
    });
}
export function fetchCompanyDetail(dispatch, params) {
    const url = `/api/v1/cloud/company-detail?company=${params.company}`;
    return rcAjax('GET', url, {}, {}, data => {
        dispatch({type: GET_COMPANY_DETAIL, data: data.data});
    });
}

/**
 * 我的认证-卡片&&落地页 数据展示
 * @param {function} dispatch -dispatch
 * @param {object} params - 企业名称
 * @method GET
 * @returns {Promise<object>} 对象
 * @description http://wiki.baidu.com/pages/viewpage.action?pageId=1744426625
 */
export function fetchCompanyData(dispatch, params) {
    const url = `/api/v1/cloud/company-data?company=${params?.company}`;
    return rcAjax('GET', url, {}, {}, data => {
        dispatch({type: GET_COMPANY_DATA, data: data.data});
    });
}
